import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {faFutbol} from "@fortawesome/free-regular-svg-icons"
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

export function FPLNavbar() {
  return (
    <Navbar expand={true} className="bg-body-tertiary mb-4">
      <Container>
        <Navbar.Brand as={NavLink} to="/"><FontAwesomeIcon icon={faFutbol}/>FPL Stats</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
      </Container>
    </Navbar>
  )
}
